import { Page } from '../../types'
import { COUNTRIES } from '../../defaultContent'

const addPreventedError: Page[] = [
        {
        pageType: 'question',
        title: 'Prevented fraud & error',
        name: 'prevented-error-declare-page',
        description:
            'The Prevented categories are aligned to definitions referenced in the Fraud Measurement Standard:' +
            '<ul><li>Prevented Actuals (or Point of Interdiction): The Prevented Actuals typology refers to instances of payments prevented from being processed due to the detection of fraud, where the value of the payment prevented can be evidenced with certainty.</li><li>Future Loss Prevented: These are calculated savings that evidence that fraud/error would have continued for a period of time had it not been detected in the first place, and that subsequently would have resulted in a financial loss. These calculated savings should be arrived at through evidenced and agreed assumptions.</li><li>Upstream Prevention: Upstream savings are generated from the implementation of new processes, policies or controls that reduce the amount of fraud/error in a given payment stream or scheme. These calculated savings should refer to the reduction in the level of measured fraud/error in a payment stream or scheme from baseline, measured both post- and pre-implementation.</li></ul><br/>'+
            'The reporting in this section refers to instances where the prevention of fraud (and in some cases, error) can be evidenced with certainty or via an assured prevention methodology. Reported prevention is a result of active detection or evidenced via a measurement exercise. Values recorded here should be evidenced as either an evaluated or calculated saving, and should therefore reflect a realistic and legitimate saving/benefit to the exchequer. Only methodologies approved by the Prevention Panel can be used to calculate a saving.\n'+
            'The Prevention Panel is facilitated by the PSFA for use by all public bodies wishing to claim prevented savings based on an estimated value. A methodology should either be to calculate a Future Loss Prevented or Upstream Prevention estimate. The purpose is to ensure prevented estimates and the methodologies used to calculate savings are reasonable, robust and credible.\n'+
            'The Prevention Panel Methodology Bank provides a repository of all approved savings methodologies. In order for a new methodology to be approved by the Prevention Panel a Prevention Panel submission must be completed by the originating department/organisation. The submission must be sent to psfa.performance@cabinetoffice.gov.uk no later than three weeks prior to the next Prevention Panel and on the correct template. If you require further information about the process, the Methodology Bank or upcoming meeting dates please email psfa.performance@cabinetoffice.gov.uk.\n'+
            'Please Note: All entries in this section must be allocated a selection from the typology dropdowns. Please refer to the Typologies Definition document for more detail.',
        questions: [
            {
                questionType: 'radio',
                title: 'Do you have any instances of detected error to declare?',
                name: 'prevented-error-declare',
                options: ['Yes', 'No'],
                rules: {
                    required: true
                }
            }
        ]
    },
    {
        pageType: 'list',
        title: 'Add an instance of future prevented error',
        name: 'prevented-error-add-instance',
        description:
            'Prevented values should be evidenced with certainty. Prevented actuals should only refer to instances of fraud prevented, not error. Entries should also include selections from the Prevented Actuals typology dropdowns:'+
            '<ul><li>the business area where the fraud was prevented</li><li>the nature of deception - whether the prevented fraud involved a false representation, a failure to declare or disclose, or an abuse of position</li><li>the detailed nature of deception - a dependent dropdown selection on the specifics of the fraudulent activity</li><li>if applicable, the fraud enabler(s)</li><li>whether or not the fraud related to a COVID-19 scheme or activity</li></ul><br/>'+
            'Future loss prevented values should be determined through evidenced and agreed assumptions that a loss in the future was prevented as a result of detecting the fraud (e.g. payments would have continued). Savings should not be projected beyond a 12 month period. The savings methodology used should either be assured by the Prevention Panel, or refer to an approved methodology within the Prevention Panel Methodology Bank.',
        disabled: [
            {
                field: 'prevented-error-declare',
                condition: 'equals', // optional
                value: 'No'
            }
        ],
        questions: [
            {
                questionType: 'radio',
                title: 'Who was responsible for the error?',
                // hint: `You can tick both if applicable`,
                 name: 'prevented-errorr-who-responsible',
                 options: ['Customer', 'Supplier', 'Official', 'Unknown'],
                 rules: { required: true }
            },
            {
                 questionType: 'radio',
                 title: 'How were counter fraud staff involved?',
                 // hint: `You can tick both if applicable`,
                 name: 'prevented-error-fraud-involved',
                 options: ['Delivered by counter fraud staff', 'Influenced by counter fraud staff'],
                 rules: { required: true }
            },
            {
                questionType: 'select',
                title: 'Which spending area was the fraud prevented in?',
                name: 'prevented-error-area',
                detailsHeading: 'Help with spending areas',
                detailsContent: ' <b>Procurement:</b> Goods or services bought by public sector organisations (including suppliers)' +
                                ' <br/><b>Personnel:</b> Employees (including contractors and agency workers).' +
                                ' <br/><b>Subsidies:</b> Support or incentives given by the government.' +
                                ' <br/><b>Grants:</b> Money given by a public sector organisation for a specific purpose.' +
                                ' <br/><b>Loans & credit guarantees:</b> Money given by a public sector organisation for a specific purpose.' +
                                ' <br/><b>Charges & other non-tax income:</b> Money owed to public sector organisations (for example, court fines or prescription fees)' +
                                ' <br/><b>Licenses and permits:</b> Personal or business licenses (for example, a Blue Badge or Surveyor license)' +
                                ' <br/><b>Tax & Duties:</b> Mandatory government charge for goods, income or services' +
                                ' <br/><b>Benefits:</b> Money given by the government to support members of the public' +
                                ' <br/><b>Special Payments:</b> Money given in unique or specific circumstances (for example, compensation)',
                options: ['Procurement','Personnel','Subsidies','Grants','Loans & credit gurantees','Charges & other non-tax income','Licences and permits','Tax & Duties','Benefits','Special payments'],
                hintOption: 'Select an option',
                rules: {required: true},
                errorMessages: { required: 'This field is mandatory' }
            },    
            {
                questionType: 'instanceInput',
                title: 'How many instances were prevented?',
                name: 'prevented-error-impact',
                txt: `Total number of instances.`,
                rules: {
                    required: true
                }
            },
            {
                questionType: 'costInput',
                title: 'What was the value of the prevented fraud?',
                name: 'prevented-error-estimated-total',
                txt: `Total value`,
                rules: {
                    required: false
                }
            },            
            {
                questionType: 'textarea',
                title: 'Comments',
                name: 'prevented-error-comments',
                hint: `Please ensure you do not include any personal or sensitive information`,
                rules: {
                    required: false
                }
            },   
            {
                questionType: 'radio',
                title: 'Does this relate to BAU or C19 activity?',
                // hint: `You can tick both if applicable`,
                name: 'prevented-error-bau-c19',
                options: ['Business as usual (BAU)', 'Covid-19 (C19)'],
                rules: { required: true }
            }
        ]
    }
]
export default addPreventedError
